// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prodDetails{cursor:pointer}.tooltip.vue-tooltip-theme{opacity:1}
`, "",{"version":3,"sources":["webpack://./components/item-child-grid.vue"],"names":[],"mappings":"AAAA,aACE,cAAA,CAGF,2BACE,SAAA","sourcesContent":[".prodDetails {\n  cursor: pointer;\n}\n\n.tooltip.vue-tooltip-theme {\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
